import React, { useState } from 'react';
import AppointmentTypeCard from './appointment_type/AppointmentTypeCard';
import DoctorsList from './doctor_booking/DoctorsList';
import ManageAppointmentType from './appointment_type/ManageAppointmentType';
import ManageDoctor from './doctor_booking/ManageDoctor';
import ClinicSettingsSectionHeader from '../subparts/ClinicSettingsSectionHeader';
import WebBookingSegmentNav from './subparts/WebBookingSegmentNav';

const WebBooking = () => {
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [activeSegment, setActiveSegment] = useState('doctors');
    const [currentView, setCurrentView] = useState('booking');

    const handleDoctorSelect = (doctor) => {
        setSelectedDoctor(doctor);
        setCurrentView('doctorCard');
    };

    const handleBackToList = () => {
        setSelectedDoctor(null);
        setCurrentView('booking');
    };

    const handleAppointmentTypeManage = () => {
        setActiveSegment('appointmentTypes');
        setCurrentView('appointmentCard');
    };

    const handleSegmentChange = (segment) => {
        setActiveSegment(segment);
        setCurrentView('booking');
        setSelectedDoctor(null);
    };

    return (
        <>
            <ClinicSettingsSectionHeader
                title="Web Booking"
                icon="bi-globe2"
                subtitle="Manage doctors, appointment types, and online booking settings"
            />
            <div className="clinic-settings-stack">
                {currentView === 'booking' && (
                    <>
                        <WebBookingSegmentNav
                            activeSegment={activeSegment}
                            onSegmentChange={handleSegmentChange}
                        />
                        {activeSegment === 'doctors' ? (
                            <DoctorsList onDoctorSelect={handleDoctorSelect} />
                        ) : (
                            <AppointmentTypeCard onManage={handleAppointmentTypeManage} />
                        )}
                    </>
                )}
                {currentView === 'doctorCard' && (
                    <ManageDoctor
                        doctor={selectedDoctor}
                        onBack={handleBackToList}
                    />
                )}
                {currentView === 'appointmentCard' && (
                    <ManageAppointmentType onBack={handleBackToList} />
                )}
            </div>
        </>
    );
};

export default WebBooking;
